<template>
    <div>测试页面</div>
</template>

<script>
// import encrypt from "@/plugins/encrypt";
import { showVirtualSimulation } from "@/api/public/virtualExp";

export default {
    created() {
        showVirtualSimulation({
            a: 123
        });
    }
};
</script>
